import { Helmet } from "react-helmet-async";
import Logo from "../content/img/logo.png";

const Seo = ({ title, description, keywords, url }) => {

  const internalKeywords = Array.isArray(keywords) ? keywords.join(", ") : keywords;

  return (
    <Helmet>
      <title>{title}</title>
      {description && (
        <meta name="description" content={description} />
      )}
      <meta name="keywords" content={internalKeywords} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={Logo} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={Logo} />

    </Helmet>
  );
};

export default Seo;
